import { createRouter, createWebHistory } from 'vue-router'
import LandingPage from '../components/LandingPage.vue'
import Room from '../components/Room.vue'
import SessionClient from '../components/SessionClient.vue'
import PrivacyPolicy from '@/components/PrivacyPolicy.vue'

const routes = [
  {
    path: '/',
    name: 'LandingPage',
    component: LandingPage
  },
  {
    path: '/room/:roomId',
    name: 'Room',
    component: Room
  },
  {
    path: '/join/:roomId',
    name: 'SessionClient',
    component: SessionClient
  },
  {
    path: '/privacy',
    name: 'Privacy',
    component: PrivacyPolicy
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

import { useAnalytics } from '../composables/useAnalytics'
const { trackPageView } = useAnalytics()

router.afterEach((to) => {
  trackPageView(to.name, { path: to.path })
})

export default router
